import { useState } from "react";
import { useAuth } from "app/providers/authContext";
import bitacoraService from "modules/bitacora/services/bitacoraService";

export const useFormJobOrder = () => {
  const { token } = useAuth();

  const initialForm = {
    fechaHora: "",
    tecnico: "",
    comercio: "",
    zone: "",
    duracion: "",
    nomenclatura: "",
    activity: "",
    description: "",
  };

  const [formData, setFormData] = useState(initialForm);

  // Actividades (puedes dejar precargadas para pruebas)
  const [actividades, setActividades] = useState([
    {
      zone: "Zona Norte",
      duracion: "2h",
      nomenclatura: "ZN-101",
      activity: "Instalación de equipo de red",
      description: "Instalación de router y configuración de red inalámbrica en el comercio.",
    },
    {
      zone: "Zona Centro",
      duracion: "1.5h",
      nomenclatura: "CT-204",
      activity: "Mantenimiento preventivo",
      description: "Revisión y limpieza de equipos eléctricos para evitar fallas futuras.",
    },
  ]);

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState(null);
  const [submitSuccess, setSubmitSuccess] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const agregarActividad = () => {
    if (!formData.zone || !formData.nomenclatura || !formData.activity || !formData.description) {
      setSubmitError("Completa todos los campos de la actividad");
      return;
    }

    const nuevaActividad = {
      zone: formData.zone,
      duracion: formData.duracion,
      nomenclatura: formData.nomenclatura,
      activity: formData.activity,
      description: formData.description,
      completed: false,
    };

    setActividades((prev) => [...prev, nuevaActividad]);

    // Limpiar solo campos de actividad
    setFormData((prev) => ({
      ...prev,
      zone: "",
      duracion: "",
      nomenclatura: "",
      activity: "",
      description: "",
    }));
  };

  const eliminarActividad = (index) => {
    setActividades((prev) => prev.filter((_, i) => i !== index));
  };

  // Envío completo del agendamiento (usa actividades, que puede incluir evidencias y firmas)
  const handleSubmit = async (e) => {
    e && e.preventDefault();
    setSubmitError(null);

    if (!formData.fechaHora || !formData.tecnico || !formData.comercio) {
      setSubmitError("Completa todos los campos del agendamiento");
      return;
    }

    if (actividades.length === 0) {
      setSubmitError("Debes agregar al menos una actividad");
      return;
    }

    try {
      setIsSubmitting(true);

      const payload = {
        fechaHora: formData.fechaHora,
        tecnico: formData.tecnico,
        comercio: formData.comercio,
        actividades,
      };

      const result = await bitacoraService.sendBitacora(payload, token);

      if (result.success) {
        setSubmitSuccess(true);
        setFormData(initialForm);
        setActividades([]);
      } else {
        setSubmitError(result.error || "Error al enviar el agendamiento");
      }
    } catch (error) {
      setSubmitError("Error inesperado al procesar la solicitud");
    } finally {
      setIsSubmitting(false);
    }
  };

  return {
    formData,
    actividades,
    setActividades,
    isSubmitting,
    submitError,
    submitSuccess,
    handleChange,
    agregarActividad,
    eliminarActividad,
    handleSubmit,
    setSubmitError,
    setSubmitSuccess,
    setFormData,
  };
};
